import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Button from '@jd/jmtd/es/Button';
import Icon from '@jd/jmtd/es/Icon';
import { FormGroupContext } from '../FormGroup/context';
export default function FormGroupMoreButton(props) {
  return /*#__PURE__*/React.createElement(FormGroupContext.Consumer, null, function (_ref) {
    var more = _ref.more,
        trackEvent = _ref.trackEvent;
    return /*#__PURE__*/React.createElement(Button, _extends({
      "data-event-name": "more",
      outline: true,
      className: "jmtp-form-group-more-button",
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        className: "jmti-angle-double-down"
      }),
      onClick: function onClick() {
        more();
        trackEvent('more');
      }
    }, props));
  });
}